import React, { useEffect, useState } from 'react';
import FranjaMarca, { COLORES_MARCA } from './FranjaMarca';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import useEsMovil from '../hooks/useEsMovil';

// Cartel de bienvenida al iniciar sesión: saluda a quien entra por su nombre
// y le deja una frase linda para arrancar el día (pedido de Mica, 2026-10-24).
// Login.js marca "saludo_pendiente" al entrar; acá se muestra una sola vez.
// Las frases no se repiten para la misma persona hasta haber visto todas
// (se recuerda en este navegador).
const CLAVE = 'saludo_pendiente';

const FRASES = [
  { emoji: '🎨', texto: 'Que hoy sea un día lleno de colores, como el local.' },
  { emoji: '💛', texto: 'Gracias por todo lo que ponés acá: se nota y suma muchísimo.' },
  { emoji: '✨', texto: 'Hoy va a ser un gran día. ¡Vamos con todo!' },
  { emoji: '🌻', texto: 'Tu buena onda hace que este lugar sea más lindo.' },
  { emoji: '💪', texto: 'Paso a paso se hacen cosas enormes. Hoy también.' },
  { emoji: '🧉', texto: 'Ojalá hoy te toquen clientes amables y mates calentitos.' },
  { emoji: '🌷', texto: 'Lo que hacés importa, y mucho. Gracias por estar.' },
  { emoji: '🌈', texto: 'Respirá hondo, sonreí, y a crear. Hoy sale todo bien.' },
  { emoji: '🖌️', texto: 'Sos parte de lo que hace especial a Tu Artística.' },
  { emoji: '☀️', texto: 'Que el día te trate tan bien como vos tratás a los demás.' },
  { emoji: '⭐', texto: 'Hoy es un buen día para estar orgullosa de vos.' },
  { emoji: '💐', texto: 'Cada día tu trabajo deja algo lindo en alguien.' },
  { emoji: '🍫', texto: 'Tomate un ratito para vos hoy también, te lo merecés.' },
  { emoji: '🤗', texto: 'Con vos en el equipo todo es más fácil. ¡Gracias!' },
  { emoji: '😄', texto: 'Que hoy encuentres un motivo para reírte fuerte.' },
  { emoji: '🦋', texto: 'Las cosas lindas pasan cuando menos las esperás. Hoy puede ser una.' },
  { emoji: '🌸', texto: 'Tu sonrisa le alegra el día a más gente de la que te imaginás.' },
  { emoji: '🍀', texto: 'Hoy tenés toda la suerte de tu lado.' },
  { emoji: '🎉', texto: 'Celebrá cada pequeño logro de hoy, todos cuentan.' },
  { emoji: '🌞', texto: 'Arrancá el día con calma: todo lo que venga, lo vas a resolver.' },
  { emoji: '🧡', texto: 'Qué lindo es trabajar con alguien como vos.' },
  { emoji: '🖍️', texto: 'Hoy pintá tu día del color que más te guste.' },
  { emoji: '🌼', texto: 'Sos más capaz de lo que creés. Siempre.' },
  { emoji: '🍓', texto: 'Que el día de hoy sea dulce de principio a fin.' },
  { emoji: '🎶', texto: 'Ponele música a tu día y dejá que fluya.' },
  { emoji: '🌄', texto: 'Como los girasoles: hoy buscá siempre el lado con sol.' },
  { emoji: '💫', texto: 'Brillás aunque no te des cuenta.' },
  { emoji: '🐝', texto: 'Tu esfuerzo de todos los días es pura magia. ¡Gracias!' },
  { emoji: '🌺', texto: 'Merecés un día tan lindo como vos.' },
  { emoji: '✏️', texto: 'Hoy es una hoja en blanco: escribí algo hermoso.' },
  { emoji: '🎁', texto: 'Cada día es un regalo, y hoy viene con moño.' },
  { emoji: '🌙', texto: 'Hagas lo que hagas hoy, a la noche vas a estar orgullosa.' },
  { emoji: '🍰', texto: 'Hoy te mereces algo rico. Date un gustito.' },
  { emoji: '🎈', texto: 'Soltá lo que pesa y dejá que el día te lleve liviana.' },
  { emoji: '🌿', texto: 'Respirá. Estás haciendo las cosas muy bien.' },
  { emoji: '💖', texto: 'Este lugar es mejor porque vos estás en él.' },
  { emoji: '🖼️', texto: 'Todo lo lindo empieza con un primer trazo. ¡A trazar!' },
  { emoji: '☕', texto: 'Café, buena onda y a romperla. Hoy es tu día.' },
  { emoji: '🌟', texto: 'Hoy alguien va a sonreír gracias a vos.' },
  { emoji: '🐞', texto: 'Las pequeñas cosas hacen los días grandes.' },
  { emoji: '🍋', texto: 'Si el día viene con limones, armamos limonada juntas.' },
  { emoji: '⚡', texto: 'Tu energía contagia. ¡Seguí así!' },
  { emoji: '🎀', texto: 'Hoy ponete linda por dentro y por fuera: ya lo sos.' },
  { emoji: '🦄', texto: 'Sos única, y eso es lo mejor que tenés.' },
  { emoji: '🌅', texto: 'Cada mañana es una nueva oportunidad para que todo salga bien.' },
  { emoji: '🧁', texto: 'Que tu día sea tan rico como una tarde de merienda.' },
  { emoji: '🎯', texto: 'Hoy vas a lograr todo lo que te propongas.' },
  { emoji: '🌱', texto: 'Florecé a tu ritmo, que vas re bien.' },
  { emoji: '💌', texto: 'Este mensajito es para decirte: gracias por ser como sos.' },
  { emoji: '🪁', texto: 'Hoy dejá que tus ideas vuelen alto.' },
  { emoji: '🌍', texto: 'El mundo es más lindo con gente como vos.' },
  { emoji: '🫶', texto: 'Un abrazo grande para arrancar el día.' },
  { emoji: '🎭', texto: 'La vida es como un lienzo: hoy sumale un color nuevo.' },
  { emoji: '🍩', texto: 'Que hoy no falten las risas ni las cosas ricas.' },
  { emoji: '🌤️', texto: 'Aunque esté nublado, vos traés el sol.' },
  { emoji: '🏆', texto: 'Sos una campeona en lo que hacés.' },
  { emoji: '🕊️', texto: 'Hoy regalate paciencia y cariño. Vos primero.' },
  { emoji: '🧸', texto: 'Que el día te abrace tan lindo como vos abrazás a los demás.' },
  { emoji: '🎆', texto: 'Hoy puede pasar algo increíble. Estate atenta.' },
  { emoji: '🏡', texto: 'Gracias por cuidar este lugar como si fuera tuyo.' },
];

// Para la dueña (rol admin): frases propias, además de las de todas.
const FRASES_DUENA = [
  { emoji: '👑', texto: 'Construiste algo hermoso. Tu Artística existe gracias a vos.' },
  { emoji: '🚀', texto: 'Cada idea tuya hace crecer este sueño. ¡Seguí soñando grande!' },
  { emoji: '🏰', texto: 'Mirá todo lo que armaste: es para estar muy orgullosa.' },
  { emoji: '🌳', texto: 'Lo que plantaste hoy da sombra y frutos para todo el equipo.' },
  { emoji: '🧭', texto: 'Tu equipo te sigue porque confía en vos. Y con razón.' },
  { emoji: '💎', texto: 'Ser la dueña no es fácil, y lo hacés con mucho corazón.' },
  { emoji: '🔥', texto: 'Tu pasión es el motor de todo esto. ¡Qué orgullo!' },
  { emoji: '🎇', texto: 'Hoy también vas a hacer magia. Como siempre.' },
  { emoji: '🛋️', texto: 'Acordate de descansar un poco: la jefa también se lo merece.' },
  { emoji: '🌠', texto: 'Todo lo grande empezó con alguien que se animó. Esa sos vos.' },
  { emoji: '🫂', texto: 'No estás sola: tenés un equipo que te quiere y te banca.' },
  { emoji: '🏅', texto: 'Cada día que abrís el local es un logro. ¡Felicitaciones!' },
];

const PAPELITOS =['🎨', '✨', '💛', '🌸', '⭐', '🖌️', '🌼', '💖'];
const COLORES_CONFETI = [COLORES_MARCA.rojo, COLORES_MARCA.azul, COLORES_MARCA.amarillo];

export function marcarSaludoPendiente() {
  try { sessionStorage.setItem(CLAVE, '1'); } catch (_) { /* sin storage */ }
}

function saludoSegunHora() {
  const hora = new Date().getHours();
  if (hora < 13) return 'Buen día';
  if (hora < 20) return 'Buenas tardes';
  return 'Buenas noches';
}

// Elige una frase que esa persona todavía no vio; cuando las vio todas,
// arranca de nuevo.
function elegirFrase(nombre, esDuena) {
  const lista = esDuena ? [...FRASES_DUENA, ...FRASES] : FRASES;
  const clave = `saludo_frases_vistas_${esDuena ? 'duena_' : ''}${nombre || 'anon'}`;
  let vistas = [];
  try { vistas = JSON.parse(localStorage.getItem(clave) || '[]'); } catch (_) { vistas = []; }
  let disponibles = lista.map((_, i) => i).filter((i) => !vistas.includes(i));
  if (disponibles.length === 0) { vistas = []; disponibles = lista.map((_, i) => i); }
  // A la dueña le salen primero sus frases propias.
  const propias = disponibles.filter((i) => i < (esDuena ? FRASES_DUENA.length : 0));
  const opciones = propias.length > 0 ? propias : disponibles;
  const elegida = opciones[Math.floor(Math.random() * opciones.length)];
  try { localStorage.setItem(clave, JSON.stringify([...vistas, elegida])); } catch (_) { /* sin storage */ }
  return lista[elegida];
}

// Papelitos de colores y emojis que caen detrás del cartel.
function Confeti() {
  const piezas = Array.from({ length: 28 }, (_, i) => {
    const esEmoji = i % 3 === 0;
    return {
      id: i,
      izquierda: Math.random() * 100,
      demora: Math.random() * 2.5,
      duracion: 3.5 + Math.random() * 3,
      giro: Math.random() * 360,
      contenido: esEmoji ? PAPELITOS[i % PAPELITOS.length] : null,
      color: COLORES_CONFETI[i % COLORES_CONFETI.length],
      tamano: esEmoji ? 22 : 8 + Math.random() * 6,
      redondo: i % 2 === 0,
    };
  });
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
      {piezas.map((p) => (
        <span
          key={p.id}
          style={{
            position: 'absolute', top: '-40px', left: `${p.izquierda}%`,
            fontSize: `${p.tamano}px`, lineHeight: 1,
            width: p.contenido ? 'auto' : `${p.tamano}px`,
            height: p.contenido ? 'auto' : `${p.tamano * (p.redondo ? 1 : 0.5)}px`,
            background: p.contenido ? 'none' : p.color,
            borderRadius: p.redondo ? '50%' : '2px',
            transform: `rotate(${p.giro}deg)`,
            animation: `saludo-caer ${p.duracion}s linear ${p.demora}s infinite`,
          }}
        >
          {p.contenido}
        </span>
      ))}
    </div>
  );
}

// Dibujito de pinceladas y estrellitas con los colores del local.
function Decoracion() {
  return (
    <svg viewBox="0 0 200 60" width="200" height="60" aria-hidden="true" style={{ display: 'block', margin: '0 auto' }}>
      <path d="M20 40 Q60 10 100 35 T180 30" fill="none" stroke={COLORES_MARCA.amarillo} strokeWidth="7" strokeLinecap="round" opacity="0.85" />
      <path d="M30 48 Q80 25 120 45 T175 42" fill="none" stroke={COLORES_MARCA.rojo} strokeWidth="4" strokeLinecap="round" opacity="0.6" />
      {[[18, 18, COLORES_MARCA.azul], [182, 14, COLORES_MARCA.rojo], [100, 10, COLORES_MARCA.amarillo]].map(([x, y, c]) => (
        <path
          key={`${x}-${y}`}
          d={`M${x} ${y - 8} L${x + 2.5} ${y - 2.5} L${x + 8} ${y} L${x + 2.5} ${y + 2.5} L${x} ${y + 8} L${x - 2.5} ${y + 2.5} L${x - 8} ${y} L${x - 2.5} ${y - 2.5} Z`}
          fill={c}
          style={{ animation: 'saludo-titilar 1.8s ease-in-out infinite', transformOrigin: `${x}px ${y}px` }}
        />
      ))}
    </svg>
  );
}

function SaludoBienvenida({ nombre, esDuena }) {
  const esMovil = useEsMovil();
  const [visible, setVisible] = useState(() => {
    try { return sessionStorage.getItem(CLAVE) === '1'; } catch (_) { return false; }
  });
  const [frase, setFrase] = useState(null);
  // Se borra la marca apenas se muestra, así no vuelve a salir al volver al panel.
  useEffect(() => {
    try { sessionStorage.removeItem(CLAVE); } catch (_) { /* sin storage */ }
    if (!visible) return;
    // Mensaje del día escrito según su signo, el mismo en todas las compus y
    // sin repetir (2026-10-30). Si tarda o falla, sale una frase fija.
    let listo = false;
    const usarFija = () => { if (!listo) { listo = true; setFrase(elegirFrase(nombre, esDuena)); } };
    const espera = setTimeout(usarFija, 15000);
    httpsCallable(functions, 'saludoDelDiaStaff', { timeout: 20000 })()
      .then(({ data }) => {
        if (listo) return;
        if (data?.saludo?.texto) {
          listo = true;
          setFrase({ emoji: data.saludo.emoji, texto: data.saludo.texto, signo: data.saludo.signo, luna: data.saludo.luna });
        } else {
          usarFija();
        }
      })
      .catch(usarFija)
      .finally(() => clearTimeout(espera));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) return null;
  const mostrada = frase || { emoji: '🔮', texto: 'Mirando qué te dicen los astros hoy...', cargando: true };
  const cerrar = () => setVisible(false);

  return (
    <div
      onClick={cerrar}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '16px', boxSizing: 'border-box',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <style>{`
        @keyframes saludo-caer {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(110vh) rotate(540deg); opacity: 0.6; }
        }
        @keyframes saludo-rebote {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-10px) scale(1.08); }
        }
        @keyframes saludo-titilar {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(0.6); opacity: 0.5; }
        }
        @keyframes saludo-aparecer {
          0% { transform: scale(0.85); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        @media (prefers-reduced-motion: reduce) {
          .saludo-animado, .saludo-animado * { animation: none !important; }
        }
      `}</style>
      <div className="saludo-animado" style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
        <Confeti />
      </div>
      <div
        className="saludo-animado"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          background: 'white', borderRadius: '20px', overflow: 'hidden',
          width: '100%', maxWidth: '400px', textAlign: 'center',
          maxHeight: '90vh', overflowY: 'auto',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          animation: 'saludo-aparecer 0.35s ease-out',
        }}
      >
        <FranjaMarca alto={10} />
        <div style={{ padding: esMovil ? '20px 18px 22px' : '24px 28px 28px' }}>
          <div style={{
            width: '110px', height: '110px', margin: '0 auto',
            borderRadius: '50%', background: '#FFF6D6',
            border: `4px solid ${COLORES_MARCA.amarillo}`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ fontSize: '60px', lineHeight: 1, animation: 'saludo-rebote 1.6s ease-in-out infinite' }}>
              {mostrada.emoji}
            </span>
          </div>
          <h2 style={{ margin: '16px 0 4px', color: COLORES_MARCA.azul, fontSize: esMovil ? '21px' : '24px' }}>
            ¡{saludoSegunHora()}{nombre ? `, ${nombre}` : ''}! 👋
          </h2>
          <Decoracion />
          <p style={{ margin: '4px 0 24px', color: '#333', fontSize: esMovil ? '16px' : '18px', lineHeight: 1.45 }}>
            <span style={mostrada.cargando ? { color: '#999', fontStyle: 'italic' } : undefined}>{mostrada.texto}</span>
            {mostrada.luna && (
              <span style={{ display: 'block', marginTop: '10px', fontSize: '14px', color: '#555' }}>
                {mostrada.luna}
              </span>
            )}
            {mostrada.signo && (
              <span style={{ display: 'block', marginTop: '6px', fontSize: '13px', color: '#999' }}>
                ✨ Para {mostrada.signo}
              </span>
            )}
          </p>
          <button
            onClick={cerrar}
            autoFocus
            style={{
              width: '100%', padding: '14px',
              background: COLORES_MARCA.rojo, color: 'white',
              border: 'none', borderRadius: '10px',
              fontSize: '16px', fontWeight: 'bold', cursor: 'pointer',
            }}
          >
            ¡Gracias! A empezar 💛
          </button>
        </div>
      </div>
    </div>
  );
}

export default SaludoBienvenida;
